import { render, staticRenderFns } from "./ModalCriterion.vue?vue&type=template&id=72c99b5e&scoped=true&"
import script from "./ModalCriterion.vue?vue&type=script&lang=js&"
export * from "./ModalCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c99b5e",
  null
  
)

export default component.exports